import { getAuthHeaders } from '../../utils/token';

export const api = '';
const BASE_URL = api + '/api/usuarios'; //modificar la url a la necesitada
// userService.ts
type Role =
  | 'user'
  | 'administrativo'
  | 'admin'
  | 'enfermeria'
  | 'emergencias'
  | 'traumatologia'
  | 'pediatria'
  | 'radiologiaTecnico'
  | 'radiologiaInterno'
  | 'medicoExterno'
  | 'medico general'
  | 'sala de dictados rayos x'
  | 'sala de dictados tomografia';
export interface APIUser {
  _id: string;
  nombre: string;
  correo: string;
  role: Role;
  vistas: string[];
  status: 'active' | 'inactive';
  fechaCreacion: string;
}
export type UserPassword = {
  id: string;
  password: string;
  newpassword: string;
  newpasswordConfirmate: string;
};
export type UpdatePassword = {
  password: string;
  newpassword: string;
  newpasswordConfirmate: string;
};
export type User = {
  id: string;
  name: string;
  email: string;
  contraseña: string;
  role: Role;
  status: 'active' | 'inactive';
  vistas: string[];
  createdAt: string;
};

export type CreateUserData = {
  name: string;
  email: string;
  contraseña: string;
  role: Role;
  vistas: string[];
  status: 'active' | 'inactive';
};

export async function fetchUsers(): Promise<APIUser[]> {
  const response = await fetch(BASE_URL, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error('Error al obtener usuarios');
  }
  return response.json();
}

export async function createUser(userData: {
  nombre: string;
  correo: string;
  role: Role;
  vistas: string[];
  contraseña: string;
}): Promise<APIUser> {
  const response = await fetch(BASE_URL, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    throw new Error('Error al crear usuario');
  }
  return response.json();
}

export async function updateUser(id: string, userData: Partial<APIUser>): Promise<APIUser> {
  const response = await fetch(`${BASE_URL}/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });
  if (!response.ok) {
    throw new Error('Error al actualizar usuario');
  }
  return response.json();
}
export async function updatePass(id: string, userData: UpdatePassword): Promise<any> {
  const response = await fetch(`${BASE_URL}/pass/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(userData),
  });

  const data = await response.json(); // <-- debes esperar el JSON antes de usarlo
  if (!response.ok) {
    console.error('Error al actualizar contraseña:', data);
    throw new Error(data.message || 'Error al actualizar contraseña');
  }

  return data;
}

export async function deleteUser(id: string): Promise<void> {
  const response = await fetch(`${BASE_URL}/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  if (!response.ok) {
    throw new Error('Error al eliminar usuario');
  }
}
